package com.exura.components.buttons

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.exura.components.icons.InlineIcon
import com.exura.components.loading.InlineLoaderVariant
import com.exura.components.loading.Loader
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.CssStyleVariant
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.coroutines.launch


@Suppress("AssignedValueIsNeverRead")
@Composable
fun AsyncButton(
    text: String,
    onClick: suspend () -> Unit,
    modifier: Modifier = Modifier,
    variant: CssStyleVariant<ButtonKind>? = ButtonPrimaryVariant,
    isDisabled: Boolean = false,
    icon: (@Composable () -> Unit)? = null,
    onError: ((Throwable) -> Unit)? = null,
) {
    val scope = rememberCoroutineScope()

    var isActionInProgress by remember { mutableStateOf(false) }

    AppButton(
        text = text,
        modifier = modifier,
        variant = variant,
        icon = icon,
        isDisabled = isDisabled || isActionInProgress,
        isLoading = isActionInProgress,
        onClick = {
            if (!isActionInProgress && !isDisabled) {
                isActionInProgress = true
                scope.launch {
                    try {
                        onClick()
                    } catch (e: Throwable) {
                        onError?.invoke(e)
                        e.printStackTrace()
                    } finally {
                        isActionInProgress = false
                    }
                }
            }
        }
    )
}


@Composable
fun AppButton(
    text: String,
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
    variant: CssStyleVariant<ButtonKind>? = ButtonPrimaryVariant,
    isDisabled: Boolean = false,
    isLoading: Boolean = false,
    icon: (@Composable () -> Unit)? = null,
) {
    Row(
        modifier = AppButtonStyle
            .toModifier(
                variant,
                if(isDisabled || isLoading) ButtonDisabledVariant else null
            )
            .onClick {
                it.stopPropagation()
                if (!isDisabled) onClick()
            }
            .then(modifier),
        verticalAlignment = Alignment.CenterVertically,
    ) {
        if (!isLoading) {
            InlineIcon(
                icon = { icon?.invoke() }
            ) {
                if(text.isNotBlank()) {
                    SpanText(text)
                }
            }
        } else {
            Loader(
                overlayVariant = null,
                loaderVariant = InlineLoaderVariant,
            )
        }
    }
}
